import { render, staticRenderFns } from "./familyDialog.vue?vue&type=template&id=0feaa1ba&scoped=true"
import script from "./familyDialog.vue?vue&type=script&lang=js"
export * from "./familyDialog.vue?vue&type=script&lang=js"
import style0 from "./familyDialog.vue?vue&type=style&index=0&id=0feaa1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feaa1ba",
  null
  
)

export default component.exports